import React from "react";
import DisclosureCore from "../../../utils/disclosure/DisclosureCore";
import Paragraph from "../../../elements/p/Paragraph";
import Container from "../../../utils/Container";
import H3 from "../../../elements/titles/H3";
import introductionVideo from "../../../../medias/videos/nti-explication-générale.mp4";
import editImageVideo from "../../../../medias/videos/nti-retoucher-image.mp4";
const PresentationVideos = () => {
  return (
    <Container>
      <DisclosureCore title="Vidéos d'explication (5 minutes x 2)">
        <div>
          <H3>Explication générale</H3>
          <Paragraph>
            Dans cette vidéo, je vous présente en{" "}
            <em className="font-semibold">5 minutes</em> comment fonctionne la
            plateforme de manière générale. Juste en dessous il y a une seconde
            vidéo pensez aussi à la regarder.
          </Paragraph>
          <video controls className="mx-auto mt-10 w-full max-w-4xl">
            <source src={introductionVideo} type="video/mp4" />
            <p>Votre navigateur ne prend pas en charge les vidéos HTML5.</p>
          </video>
        </div>

        <div className="mt-20">
          <H3>
            Comment modifier les images des produits avant de les publier ?
          </H3>
          <Paragraph>
            Je vous explique ici en 5 minutes comment modifier les images afin
            qu'elles sont bien présentables sur le site après la publication.
          </Paragraph>
          <video controls className="mx-auto mt-10 w-full max-w-4xl">
            <source src={editImageVideo} type="video/mp4" />
            <p>Votre navigateur ne prend pas en charge les vidéos HTML5.</p>
          </video>
        </div>
      </DisclosureCore>
    </Container>
  );
};

export default PresentationVideos;
